import { render } from "./TransactionDefaultSettings.vue?vue&type=template&id=28b3e06a&scoped=true"
import script from "./TransactionDefaultSettings.vue?vue&type=script&lang=js"
export * from "./TransactionDefaultSettings.vue?vue&type=script&lang=js"

import "./TransactionDefaultSettings.vue?vue&type=style&index=0&id=28b3e06a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b3e06a"]])

export default __exports__